import { useWindowDimensions } from "@-/com.npmjs.react-native";
import { useAnimatedStyle, useSharedValue } from "@-/com.npmjs.react-native-reanimated";
import { learnMapCardTravel } from "#learn-map-cards-motion";
import { useLearnMapModeSelector } from "#use-learn-map-mode";

/**
 * Slides Learn's card (the deck's, and the summary card over it) up and out of view as the map
 * opens, over Learn's toolbar, and back down as it closes. Nothing else of the cards moves: the
 * chrome it passes over is replaced beneath it, and the map's sheet slides in over the controls
 * below it.
 */
export function useLearnMapCardSlideStyle() {
  const cardsProgress = useSharedValue(0);
  const progress = useLearnMapModeSelector((mode) => mode.progress) ?? cardsProgress;
  const { height: windowHeight } = useWindowDimensions();
  return useAnimatedStyle(() => ({
    transform: [{ translateY: -learnMapCardTravel(progress.get(), windowHeight) }],
  }));
}
